import VueRouter from 'vue-router'
import routes from './routes'

const router = new VueRouter({
  mode: 'history',
  base: '/oper',
  routes: routes
})

router.beforeEach(async (to, from, next) => {
  const autenticado = localStorage.getItem('token')

  if (!autenticado && to.meta.requiresAuth) {
    next({ path: '/login' })
  } else if (autenticado && !to.meta.requiresAuth) {
    next({ path: '/home' })
  } else {
    next()
  }
})

export default router
